export const Logo = ({ className = "h-8" }) => (
  <svg viewBox="0 0 230 56" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="R-AN logo">
    <path d="M8 46V10h26c9 0 14.5 5 14.5 12.5 0 5.6-3.2 9.6-8.4 11.2L50 46H36.5l-8.3-11H19v11H8zm11-20h12.6c3.4 0 5.4-1.6 5.4-4s-2-4-5.4-4H19v8z" fill="#00F0FF" />
    <g stroke="#FF0055" strokeWidth="3" strokeLinecap="square">
      <line x1="58" y1="28" x2="58" y2="28.01" />
      <line x1="58" y1="22" x2="58" y2="34" />
      <line x1="65" y1="16" x2="65" y2="40" />
      <line x1="72" y1="22" x2="72" y2="34" />
    </g>
    <path d="M80 46L96.5 10H110l16.5 36h-12.6l-2.7-6.6h-15.9L92.6 46H80zm18.8-15.4h8.9l-4.4-10.8-4.5 10.8z" fill="#F8FAFC" />
    <path d="M132 46V10h11.4L160 31.5V10h11v36h-11.4L143 24.5V46h-11z" fill="#F8FAFC" />
    <rect x="178" y="42" width="44" height="4" fill="#00FF66" />
    <text x="178" y="38" fill="#64748B" fontFamily="JetBrains Mono, monospace" fontSize="11" letterSpacing="2">.APP</text>
  </svg>
);

export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect width="64" height="64" rx="8" fill="#0E0E14" stroke="rgba(255,255,255,0.1)" />
    <path d="M14 46V18h14c6 0 10 3.5 10 9 0 4-2.2 6.8-5.8 8L40 46h-9l-6.6-10H22v10h-8zm8-16h5.4c2.6 0 4.2-1.2 4.2-3s-1.6-3-4.2-3H22v6z" fill="#00F0FF" />
    <rect x="42" y="30" width="10" height="4" fill="#FF0055" />
  </svg>
);
